// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"4619875f","587":"16968bc3","899":"a76051f2"}[chunkId] + ".css";
};